export default "skymp5-front/97e214d1257ee8e2ed93aead109f393e.jpg";